import React from "react";

interface RedeemAwardsIllustrationIconProps
  extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

const RedeemAwardsIllustrationIcon: React.FC<
  RedeemAwardsIllustrationIconProps
> = ({ width = 76, height = 124, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 71 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="37.0308"
      y="23.9316"
      width="7.87882"
      height="7.841"
      rx="3.9205"
      fill="#F2F0EC"
    />
    <rect
      x="25.2119"
      y="58.4316"
      width="7.87882"
      height="7.841"
      rx="3.9205"
      fill="#F2F0EC"
    />
    <path
      d="M-7.09082 111.724V81.3431C-7.09082 80.8121 -6.64196 80.3848 -6.10069 80.3848H50.997C51.5383 80.3848 52.0004 80.8121 52.0004 81.3431V126.461C52.0004 127.872 50.8386 128.999 49.4128 128.999H-4.51647C-5.94227 128.999 -7.09082 127.872 -7.09082 126.461V124.505M-7.09082 111.724V124.492V111.724Z"
      fill="#FFE9D9"
    />
    <path
      d="M5.51546 96.8544C5.51546 96.4214 5.86821 96.0703 6.30334 96.0703H34.6671C35.1022 96.0703 35.455 96.4214 35.455 96.8544V109.4C35.455 109.833 35.1022 110.184 34.6671 110.184H6.30334C5.86821 110.184 5.51546 109.833 5.51546 109.4V96.8544Z"
      fill="white"
    />
    <path
      d="M-10.2422 99.2067C-10.2422 98.7737 -9.88944 98.4226 -9.45431 98.4226H48.849C49.2841 98.4226 49.6369 98.7737 49.6369 99.2067V107.832C49.6369 108.265 49.2841 108.616 48.849 108.616H-9.4543C-9.88944 108.616 -10.2422 108.265 -10.2422 107.832V99.2067Z"
      fill="white"
    />
    <path
      d="M18.1179 31.0037C18.2878 31.0037 18.4577 31.0437 18.6276 31.1238L28.3758 36.3689C29.0031 36.7026 29.7479 36.1554 29.6303 35.448L27.7747 24.3439C27.7094 23.9969 27.827 23.6232 28.0884 23.3696L35.981 15.5086C36.4907 15.0015 36.2163 14.1073 35.4976 14.0139L24.5732 12.3856C24.2335 12.3322 23.9329 12.1053 23.7892 11.785L18.8889 1.68188C18.5753 1.02791 17.6606 1.02791 17.347 1.68188L12.4598 11.785C12.316 12.1053 12.0155 12.3322 11.6496 12.3856L0.738336 14.0139C0.0326979 14.1206 -0.254783 15.0015 0.267912 15.5086L8.16061 23.3696C8.42195 23.6232 8.53956 23.9969 8.47422 24.3439L6.61865 35.448C6.50105 36.1687 7.23282 36.7159 7.87312 36.3689L17.6214 31.1238C17.7782 31.0437 17.9611 31.0037 18.1179 31.0037Z"
      fill="#BCD0BF"
    />
    <path
      d="M-1.57743 61.1222C-1.4888 61.1222 -1.40017 61.1426 -1.31154 61.1835L3.77451 63.8644C4.10176 64.0349 4.49037 63.7552 4.42901 63.3937L3.46089 57.7183C3.4268 57.5409 3.48816 57.3499 3.62452 57.2203L7.74244 53.2025C8.00834 52.9433 7.86517 52.4862 7.49019 52.4385L1.79054 51.6062C1.61328 51.579 1.45647 51.463 1.38147 51.2993L-1.17519 46.1355C-1.33881 45.8012 -1.81606 45.8012 -1.97968 46.1355L-4.52952 51.2993C-4.60452 51.463 -4.76133 51.579 -4.95222 51.6062L-10.6451 52.4385C-11.0132 52.493 -11.1632 52.9433 -10.8905 53.2025L-6.77257 57.2203C-6.63621 57.3499 -6.57485 57.5409 -6.60894 57.7183L-7.57706 63.3937C-7.63842 63.7621 -7.25663 64.0417 -6.92256 63.8644L-1.83651 61.1835C-1.7547 61.1426 -1.65925 61.1222 -1.57743 61.1222Z"
      fill="#EAF0F0"
    />
    <path
      d="M53.9671 62.0666C54.1259 62.0666 54.2847 62.1031 54.4435 62.176L63.556 66.9549C64.1423 67.2589 64.8386 66.7603 64.7287 66.1159L62.9941 55.9988C62.933 55.6826 63.043 55.3421 63.2873 55.1111L70.6652 47.9489C71.1416 47.4868 70.8851 46.6721 70.2133 46.587L60.0014 45.1035C59.6838 45.0548 59.4028 44.8481 59.2685 44.5563L54.6878 35.3512C54.3946 34.7553 53.5396 34.7553 53.2464 35.3512L48.6779 44.5563C48.5436 44.8481 48.2626 45.0548 47.9206 45.1035L37.7209 46.587C37.0613 46.6843 36.7926 47.4868 37.2812 47.9489L44.6592 55.1111C44.9035 55.3421 45.0134 55.6826 44.9523 55.9988L43.2178 66.1159C43.1078 66.7725 43.7919 67.2711 44.3904 66.9549L53.5029 62.176C53.6495 62.1031 53.8205 62.0666 53.9671 62.0666Z"
      fill="#EAF0F0"
    />
    <path
      d="M44.1025 54.6921L36.5787 47.402C36.2888 47.1135 36.157 46.6808 36.302 46.3006C36.4205 45.9203 36.7631 45.6319 37.1716 45.5663L47.5812 44.0716L52.2194 34.6836C52.5883 33.9362 53.8006 33.9362 54.1563 34.6836L58.7945 44.0716L69.1909 45.5663C69.6126 45.6319 69.9552 45.9072 70.0738 46.3006C70.1924 46.6939 70.087 47.1135 69.7971 47.402L66.9114 50.1948M62.2995 54.6921L64.0652 65.011C64.1311 65.4175 63.9598 65.824 63.6436 66.06C63.4459 66.2042 63.2219 66.2698 62.9979 66.2698C62.8266 66.2698 62.6553 66.2304 62.4972 66.1517L53.1945 61.2742L43.8917 66.1517C43.5228 66.3353 43.1011 66.3091 42.7453 66.06C42.4159 65.824 42.2446 65.4175 42.3105 65.011L42.6531 63.0049"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M44.1025 54.6921L36.5787 47.402C36.2888 47.1135 36.157 46.6808 36.302 46.3006C36.4205 45.9203 36.7631 45.6319 37.1716 45.5663L47.5812 44.0716L52.2194 34.6836C52.5883 33.9362 53.8006 33.9362 54.1563 34.6836L58.7945 44.0716L69.1909 45.5663C69.6126 45.6319 69.9552 45.9072 70.0738 46.3006C70.1924 46.6939 70.087 47.1135 69.7971 47.402L66.9114 50.1948M62.2995 54.6921L64.0652 65.011C64.1311 65.4175 63.9598 65.824 63.6436 66.06C63.4459 66.2042 63.2219 66.2698 62.9979 66.2698C62.8266 66.2698 62.6553 66.2304 62.4972 66.1517L53.1945 61.2742L43.8917 66.1517C43.5228 66.3353 43.1011 66.3091 42.7453 66.06C42.4159 65.824 42.2446 65.4175 42.3105 65.011L42.6531 63.0049"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M44.1025 54.6921L36.5787 47.402C36.2888 47.1135 36.157 46.6808 36.302 46.3006C36.4205 45.9203 36.7631 45.6319 37.1716 45.5663L47.5812 44.0716L52.2194 34.6836C52.5883 33.9362 53.8006 33.9362 54.1563 34.6836L58.7945 44.0716L69.1909 45.5663C69.6126 45.6319 69.9552 45.9072 70.0738 46.3006C70.1924 46.6939 70.087 47.1135 69.7971 47.402L66.9114 50.1948M62.2995 54.6921L64.0652 65.011C64.1311 65.4175 63.9598 65.824 63.6436 66.06C63.4459 66.2042 63.2219 66.2698 62.9979 66.2698C62.8266 66.2698 62.6553 66.2304 62.4972 66.1517L53.1945 61.2742L43.8917 66.1517C43.5228 66.3353 43.1011 66.3091 42.7453 66.06C42.4159 65.824 42.2446 65.4175 42.3105 65.011L42.6531 63.0049"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M44.1025 54.6921L36.5787 47.402C36.2888 47.1135 36.157 46.6808 36.302 46.3006C36.4205 45.9203 36.7631 45.6319 37.1716 45.5663L47.5812 44.0716L52.2194 34.6836C52.5883 33.9362 53.8006 33.9362 54.1563 34.6836L58.7945 44.0716L69.1909 45.5663C69.6126 45.6319 69.9552 45.9072 70.0738 46.3006C70.1924 46.6939 70.087 47.1135 69.7971 47.402L66.9114 50.1948M62.2995 54.6921L64.0652 65.011C64.1311 65.4175 63.9598 65.824 63.6436 66.06C63.4459 66.2042 63.2219 66.2698 62.9979 66.2698C62.8266 66.2698 62.6553 66.2304 62.4972 66.1517L53.1945 61.2742L43.8917 66.1517C43.5228 66.3353 43.1011 66.3091 42.7453 66.06C42.4159 65.824 42.2446 65.4175 42.3105 65.011L42.6531 63.0049"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M12.6065 45.8827C12.6065 46.318 12.253 46.6698 11.8216 46.6698C11.3903 46.6698 11.0308 46.318 11.0308 45.8827C11.0308 45.4474 11.3843 45.1016 11.8216 45.1016C12.259 45.1016 12.6065 45.4534 12.6065 45.8827Z"
      fill="#1A1A1A"
    />
    <path
      d="M12.6065 45.8827C12.6065 46.318 12.253 46.6698 11.8216 46.6698C11.3903 46.6698 11.0308 46.318 11.0308 45.8827C11.0308 45.4474 11.3843 45.1016 11.8216 45.1016C12.259 45.1016 12.6065 45.4534 12.6065 45.8827Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M12.6065 45.8827C12.6065 46.318 12.253 46.6698 11.8216 46.6698C11.3903 46.6698 11.0308 46.318 11.0308 45.8827C11.0308 45.4474 11.3843 45.1016 11.8216 45.1016C12.259 45.1016 12.6065 45.4534 12.6065 45.8827Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M12.6065 45.8827C12.6065 46.318 12.253 46.6698 11.8216 46.6698C11.3903 46.6698 11.0308 46.318 11.0308 45.8827C11.0308 45.4474 11.3843 45.1016 11.8216 45.1016C12.259 45.1016 12.6065 45.4534 12.6065 45.8827Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M29.1519 55.2988C29.1519 55.7341 28.7998 56.0799 28.3641 56.0799C27.9283 56.0799 27.5762 55.7341 27.5762 55.2988C27.5762 54.8635 27.9224 54.5117 28.3641 54.5117C28.8057 54.5117 29.1519 54.8635 29.1519 55.2988Z"
      fill="#1A1A1A"
    />
    <path
      d="M29.1519 55.2988C29.1519 55.7341 28.7998 56.0799 28.3641 56.0799C27.9283 56.0799 27.5762 55.7341 27.5762 55.2988C27.5762 54.8635 27.9224 54.5117 28.3641 54.5117C28.8057 54.5117 29.1519 54.8635 29.1519 55.2988Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M29.1519 55.2988C29.1519 55.7341 28.7998 56.0799 28.3641 56.0799C27.9283 56.0799 27.5762 55.7341 27.5762 55.2988C27.5762 54.8635 27.9224 54.5117 28.3641 54.5117C28.8057 54.5117 29.1519 54.8635 29.1519 55.2988Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M29.1519 55.2988C29.1519 55.7341 28.7998 56.0799 28.3641 56.0799C27.9283 56.0799 27.5762 55.7341 27.5762 55.2988C27.5762 54.8635 27.9224 54.5117 28.3641 54.5117C28.8057 54.5117 29.1519 54.8635 29.1519 55.2988Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M19.6973 64.706C19.6973 65.1396 19.3438 65.4901 18.9125 65.4901C18.4811 65.4901 18.1216 65.1396 18.1216 64.706C18.1216 64.2723 18.4751 63.9219 18.9125 63.9219C19.3498 63.9219 19.6973 64.2723 19.6973 64.706Z"
      fill="#1A1A1A"
    />
    <path
      d="M19.6973 64.706C19.6973 65.1396 19.3438 65.4901 18.9125 65.4901C18.4811 65.4901 18.1216 65.1396 18.1216 64.706C18.1216 64.2723 18.4751 63.9219 18.9125 63.9219C19.3498 63.9219 19.6973 64.2723 19.6973 64.706Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M19.6973 64.706C19.6973 65.1396 19.3438 65.4901 18.9125 65.4901C18.4811 65.4901 18.1216 65.1396 18.1216 64.706C18.1216 64.2723 18.4751 63.9219 18.9125 63.9219C19.3498 63.9219 19.6973 64.2723 19.6973 64.706Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M19.6973 64.706C19.6973 65.1396 19.3438 65.4901 18.9125 65.4901C18.4811 65.4901 18.1216 65.1396 18.1216 64.706C18.1216 64.2723 18.4751 63.9219 18.9125 63.9219C19.3498 63.9219 19.6973 64.2723 19.6973 64.706Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M44.9097 18.4374C44.9097 18.8726 44.5562 19.2244 44.1249 19.2244C43.6935 19.2244 43.334 18.8726 43.334 18.4374C43.334 18.0021 43.6875 17.6562 44.1249 17.6562C44.5622 17.6562 44.9097 18.0081 44.9097 18.4374Z"
      fill="#1A1A1A"
    />
    <path
      d="M44.9097 18.4374C44.9097 18.8726 44.5562 19.2244 44.1249 19.2244C43.6935 19.2244 43.334 18.8726 43.334 18.4374C43.334 18.0021 43.6875 17.6562 44.1249 17.6562C44.5622 17.6562 44.9097 18.0081 44.9097 18.4374Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M44.9097 18.4374C44.9097 18.8726 44.5562 19.2244 44.1249 19.2244C43.6935 19.2244 43.334 18.8726 43.334 18.4374C43.334 18.0021 43.6875 17.6562 44.1249 17.6562C44.5622 17.6562 44.9097 18.0081 44.9097 18.4374Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M44.9097 18.4374C44.9097 18.8726 44.5562 19.2244 44.1249 19.2244C43.6935 19.2244 43.334 18.8726 43.334 18.4374C43.334 18.0021 43.6875 17.6562 44.1249 17.6562C44.5622 17.6562 44.9097 18.0081 44.9097 18.4374Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M59.0914 16.871C59.0914 17.3003 58.7379 17.658 58.3065 17.658C57.8751 17.658 57.5156 17.3062 57.5156 16.871C57.5156 16.4357 57.8631 16.0898 58.3065 16.0898C58.7499 16.0898 59.0914 16.4357 59.0914 16.871Z"
      fill="#1A1A1A"
    />
    <path
      d="M59.0914 16.871C59.0914 17.3003 58.7379 17.658 58.3065 17.658C57.8751 17.658 57.5156 17.3062 57.5156 16.871C57.5156 16.4357 57.8631 16.0898 58.3065 16.0898C58.7499 16.0898 59.0914 16.4357 59.0914 16.871Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M59.0914 16.871C59.0914 17.3003 58.7379 17.658 58.3065 17.658C57.8751 17.658 57.5156 17.3062 57.5156 16.871C57.5156 16.4357 57.8631 16.0898 58.3065 16.0898C58.7499 16.0898 59.0914 16.4357 59.0914 16.871Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M59.0914 16.871C59.0914 17.3003 58.7379 17.658 58.3065 17.658C57.8751 17.658 57.5156 17.3062 57.5156 16.871C57.5156 16.4357 57.8631 16.0898 58.3065 16.0898C58.7499 16.0898 59.0914 16.4357 59.0914 16.871Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M63.0304 31.7655C63.0304 32.1948 62.6769 32.5526 62.2455 32.5526C61.8141 32.5526 61.4546 32.2008 61.4546 31.7655C61.4546 31.3302 61.8021 30.9844 62.2455 30.9844C62.6888 30.9844 63.0304 31.3302 63.0304 31.7655Z"
      fill="#1A1A1A"
    />
    <path
      d="M63.0304 31.7655C63.0304 32.1948 62.6769 32.5526 62.2455 32.5526C61.8141 32.5526 61.4546 32.2008 61.4546 31.7655C61.4546 31.3302 61.8021 30.9844 62.2455 30.9844C62.6888 30.9844 63.0304 31.3302 63.0304 31.7655Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M63.0304 31.7655C63.0304 32.1948 62.6769 32.5526 62.2455 32.5526C61.8141 32.5526 61.4546 32.2008 61.4546 31.7655C61.4546 31.3302 61.8021 30.9844 62.2455 30.9844C62.6888 30.9844 63.0304 31.3302 63.0304 31.7655Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M63.0304 31.7655C63.0304 32.1948 62.6769 32.5526 62.2455 32.5526C61.8141 32.5526 61.4546 32.2008 61.4546 31.7655C61.4546 31.3302 61.8021 30.9844 62.2455 30.9844C62.6888 30.9844 63.0304 31.3302 63.0304 31.7655Z"
      fill="black"
      fill-opacity="0.2"
    />
    <path
      d="M-8.65348 110.663V79.7921C-8.65348 79.2526 -8.2107 78.8184 -7.67677 78.8184H48.6471C49.181 78.8184 49.6368 79.2526 49.6368 79.7921V125.638C49.6368 127.072 48.4908 128.217 47.0843 128.217H-6.12705C-7.53352 128.217 -8.6665 127.072 -8.6665 125.638V123.651"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M-8.65348 110.663V79.7921C-8.65348 79.2526 -8.2107 78.8184 -7.67677 78.8184H48.6471C49.181 78.8184 49.6368 79.2526 49.6368 79.7921V125.638C49.6368 127.072 48.4908 128.217 47.0843 128.217H-6.12705C-7.53352 128.217 -8.6665 127.072 -8.6665 125.638V123.651"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M-8.65348 110.663V79.7921C-8.65348 79.2526 -8.2107 78.8184 -7.67677 78.8184H48.6471C49.181 78.8184 49.6368 79.2526 49.6368 79.7921V125.638C49.6368 127.072 48.4908 128.217 47.0843 128.217H-6.12705C-7.53352 128.217 -8.6665 127.072 -8.6665 125.638V123.651"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M-8.65348 110.663V79.7921C-8.65348 79.2526 -8.2107 78.8184 -7.67677 78.8184H48.6471C49.181 78.8184 49.6368 79.2526 49.6368 79.7921V125.638C49.6368 127.072 48.4908 128.217 47.0843 128.217H-6.12705C-7.53352 128.217 -8.6665 127.072 -8.6665 125.638V123.651"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M4.55887 107.825H-7.70999C-8.23289 107.825 -8.6665 107.411 -8.6665 106.896V99.3456C-8.6665 98.818 -8.23289 98.416 -7.70999 98.416H4.55887C5.08176 98.416 5.51538 98.818 5.51538 99.3456V106.896C5.51538 107.411 5.08176 107.825 4.55887 107.825Z"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
    />
    <path
      d="M4.55887 107.825H-7.70999C-8.23289 107.825 -8.6665 107.411 -8.6665 106.896V99.3456C-8.6665 98.818 -8.23289 98.416 -7.70999 98.416H4.55887C5.08176 98.416 5.51538 98.818 5.51538 99.3456V106.896C5.51538 107.411 5.08176 107.825 4.55887 107.825Z"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
    />
    <path
      d="M4.55887 107.825H-7.70999C-8.23289 107.825 -8.6665 107.411 -8.6665 106.896V99.3456C-8.6665 98.818 -8.23289 98.416 -7.70999 98.416H4.55887C5.08176 98.416 5.51538 98.818 5.51538 99.3456V106.896C5.51538 107.411 5.08176 107.825 4.55887 107.825Z"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
    />
    <path
      d="M4.55887 107.825H-7.70999C-8.23289 107.825 -8.6665 107.411 -8.6665 106.896V99.3456C-8.6665 98.818 -8.23289 98.416 -7.70999 98.416H4.55887C5.08176 98.416 5.51538 98.818 5.51538 99.3456V106.896C5.51538 107.411 5.08176 107.825 4.55887 107.825Z"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
    />
    <path
      d="M48.6677 107.825H36.3988C35.8759 107.825 35.4551 107.411 35.4551 106.896V99.3456C35.4551 98.818 35.8887 98.416 36.3988 98.416H48.6677C49.1906 98.416 49.637 98.818 49.637 99.3456V106.896C49.637 107.411 49.1906 107.825 48.6677 107.825Z"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
    />
    <path
      d="M48.6677 107.825H36.3988C35.8759 107.825 35.4551 107.411 35.4551 106.896V99.3456C35.4551 98.818 35.8887 98.416 36.3988 98.416H48.6677C49.1906 98.416 49.637 98.818 49.637 99.3456V106.896C49.637 107.411 49.1906 107.825 48.6677 107.825Z"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
    />
    <path
      d="M48.6677 107.825H36.3988C35.8759 107.825 35.4551 107.411 35.4551 106.896V99.3456C35.4551 98.818 35.8887 98.416 36.3988 98.416H48.6677C49.1906 98.416 49.637 98.818 49.637 99.3456V106.896C49.637 107.411 49.1906 107.825 48.6677 107.825Z"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
    />
    <path
      d="M48.6677 107.825H36.3988C35.8759 107.825 35.4551 107.411 35.4551 106.896V99.3456C35.4551 98.818 35.8887 98.416 36.3988 98.416H48.6677C49.1906 98.416 49.637 98.818 49.637 99.3456V106.896C49.637 107.411 49.1906 107.825 48.6677 107.825Z"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
    />
    <path
      d="M24.4878 110.408L31.0318 113.665C31.9421 114.111 32.9976 114.059 33.8684 113.533C34.7391 113.008 35.2405 112.089 35.2405 111.078V95.2695C35.2405 94.2584 34.7259 93.3393 33.8684 92.8141C32.9976 92.2758 31.9421 92.2233 31.0318 92.6828L24.4878 95.9522"
      fill="white"
    />
    <path
      d="M24.4878 110.408L31.0318 113.665C31.9421 114.111 32.9976 114.059 33.8684 113.533C34.7391 113.008 35.2405 112.089 35.2405 111.078V95.2695C35.2405 94.2584 34.7259 93.3393 33.8684 92.8141C32.9976 92.2758 31.9421 92.2233 31.0318 92.6828L24.4878 95.9522"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M24.4878 110.408L31.0318 113.665C31.9421 114.111 32.9976 114.059 33.8684 113.533C34.7391 113.008 35.2405 112.089 35.2405 111.078V95.2695C35.2405 94.2584 34.7259 93.3393 33.8684 92.8141C32.9976 92.2758 31.9421 92.2233 31.0318 92.6828L24.4878 95.9522"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M24.4878 110.408L31.0318 113.665C31.9421 114.111 32.9976 114.059 33.8684 113.533C34.7391 113.008 35.2405 112.089 35.2405 111.078V95.2695C35.2405 94.2584 34.7259 93.3393 33.8684 92.8141C32.9976 92.2758 31.9421 92.2233 31.0318 92.6828L24.4878 95.9522"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M24.4878 110.408L31.0318 113.665C31.9421 114.111 32.9976 114.059 33.8684 113.533C34.7391 113.008 35.2405 112.089 35.2405 111.078V95.2695C35.2405 94.2584 34.7259 93.3393 33.8684 92.8141C32.9976 92.2758 31.9421 92.2233 31.0318 92.6828L24.4878 95.9522"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M16.2683 95.9391L9.72434 92.6828C8.81399 92.2364 7.75852 92.2889 6.88775 92.8141C6.01698 93.3393 5.51562 94.2584 5.51562 95.2695V111.078C5.51562 112.089 6.03017 113.008 6.88775 113.533C7.75852 114.072 8.81399 114.124 9.72434 113.665L16.2683 110.395"
      fill="white"
    />
    <path
      d="M16.2683 95.9391L9.72434 92.6828C8.81399 92.2364 7.75852 92.2889 6.88775 92.8141C6.01698 93.3393 5.51562 94.2584 5.51562 95.2695V111.078C5.51562 112.089 6.03017 113.008 6.88775 113.533C7.75852 114.072 8.81399 114.124 9.72434 113.665L16.2683 110.395"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M16.2683 95.9391L9.72434 92.6828C8.81399 92.2364 7.75852 92.2889 6.88775 92.8141C6.01698 93.3393 5.51562 94.2584 5.51562 95.2695V111.078C5.51562 112.089 6.03017 113.008 6.88775 113.533C7.75852 114.072 8.81399 114.124 9.72434 113.665L16.2683 110.395"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M16.2683 95.9391L9.72434 92.6828C8.81399 92.2364 7.75852 92.2889 6.88775 92.8141C6.01698 93.3393 5.51562 94.2584 5.51562 95.2695V111.078C5.51562 112.089 6.03017 113.008 6.88775 113.533C7.75852 114.072 8.81399 114.124 9.72434 113.665L16.2683 110.395"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M16.2683 95.9391L9.72434 92.6828C8.81399 92.2364 7.75852 92.2889 6.88775 92.8141C6.01698 93.3393 5.51562 94.2584 5.51562 95.2695V111.078C5.51562 112.089 6.03017 113.008 6.88775 113.533C7.75852 114.072 8.81399 114.124 9.72434 113.665L16.2683 110.395"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M4.72897 58.8086L4.52557 57.6426L9.24434 53.2013C9.43417 53.031 9.50197 52.769 9.42061 52.5332C9.33925 52.2973 9.1223 52.127 8.87823 52.0877L2.34247 51.1706L-0.572857 45.4455C-0.803371 44.9869 -1.56271 44.9869 -1.79323 45.4455L-4.70856 51.1706L-11.2308 52.0877C-11.4884 52.127 -11.7053 52.2973 -11.7867 52.5332C-11.8681 52.769 -11.7867 53.031 -11.6104 53.2013L-7.84084 56.7648L-6.90522 57.6426L-8.01711 63.9311C-8.05779 64.18 -7.94931 64.4289 -7.75948 64.573C-7.63744 64.6517 -7.50185 64.7041 -7.35269 64.7041C-7.24421 64.7041 -7.13573 64.6779 -7.04082 64.6254L-1.1966 61.6515L4.64761 64.6254C4.87813 64.7434 5.14932 64.7303 5.36627 64.573C5.56967 64.4289 5.67815 64.18 5.63747 63.9311"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M4.72897 58.8086L4.52557 57.6426L9.24434 53.2013C9.43417 53.031 9.50197 52.769 9.42061 52.5332C9.33925 52.2973 9.1223 52.127 8.87823 52.0877L2.34247 51.1706L-0.572857 45.4455C-0.803371 44.9869 -1.56271 44.9869 -1.79323 45.4455L-4.70856 51.1706L-11.2308 52.0877C-11.4884 52.127 -11.7053 52.2973 -11.7867 52.5332C-11.8681 52.769 -11.7867 53.031 -11.6104 53.2013L-7.84084 56.7648L-6.90522 57.6426L-8.01711 63.9311C-8.05779 64.18 -7.94931 64.4289 -7.75948 64.573C-7.63744 64.6517 -7.50185 64.7041 -7.35269 64.7041C-7.24421 64.7041 -7.13573 64.6779 -7.04082 64.6254L-1.1966 61.6515L4.64761 64.6254C4.87813 64.7434 5.14932 64.7303 5.36627 64.573C5.56967 64.4289 5.67815 64.18 5.63747 63.9311"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M4.72897 58.8086L4.52557 57.6426L9.24434 53.2013C9.43417 53.031 9.50197 52.769 9.42061 52.5332C9.33925 52.2973 9.1223 52.127 8.87823 52.0877L2.34247 51.1706L-0.572857 45.4455C-0.803371 44.9869 -1.56271 44.9869 -1.79323 45.4455L-4.70856 51.1706L-11.2308 52.0877C-11.4884 52.127 -11.7053 52.2973 -11.7867 52.5332C-11.8681 52.769 -11.7867 53.031 -11.6104 53.2013L-7.84084 56.7648L-6.90522 57.6426L-8.01711 63.9311C-8.05779 64.18 -7.94931 64.4289 -7.75948 64.573C-7.63744 64.6517 -7.50185 64.7041 -7.35269 64.7041C-7.24421 64.7041 -7.13573 64.6779 -7.04082 64.6254L-1.1966 61.6515L4.64761 64.6254C4.87813 64.7434 5.14932 64.7303 5.36627 64.573C5.56967 64.4289 5.67815 64.18 5.63747 63.9311"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M4.72897 58.8086L4.52557 57.6426L9.24434 53.2013C9.43417 53.031 9.50197 52.769 9.42061 52.5332C9.33925 52.2973 9.1223 52.127 8.87823 52.0877L2.34247 51.1706L-0.572857 45.4455C-0.803371 44.9869 -1.56271 44.9869 -1.79323 45.4455L-4.70856 51.1706L-11.2308 52.0877C-11.4884 52.127 -11.7053 52.2973 -11.7867 52.5332C-11.8681 52.769 -11.7867 53.031 -11.6104 53.2013L-7.84084 56.7648L-6.90522 57.6426L-8.01711 63.9311C-8.05779 64.18 -7.94931 64.4289 -7.75948 64.573C-7.63744 64.6517 -7.50185 64.7041 -7.35269 64.7041C-7.24421 64.7041 -7.13573 64.6779 -7.04082 64.6254L-1.1966 61.6515L4.64761 64.6254C4.87813 64.7434 5.14932 64.7303 5.36627 64.573C5.56967 64.4289 5.67815 64.18 5.63747 63.9311"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M29.5746 34.3104L27.9029 24.7758L36.6429 16.417C36.9851 16.094 37.1299 15.603 36.9588 15.1509C36.814 14.7116 36.4191 14.3757 35.9584 14.3111L23.8489 12.5928L18.4522 1.83092C18.031 0.978236 16.6226 0.978236 16.2014 1.83092L10.8048 12.5928L-1.27848 14.3111C-1.76549 14.3757 -2.16037 14.7116 -2.30516 15.1509C-2.44995 15.5901 -2.31832 16.094 -1.97609 16.417L1.38036 19.621M6.75069 24.7888L4.69732 36.61C4.61835 37.0751 4.81579 37.5532 5.18434 37.8115C5.4081 37.9666 5.67135 38.0441 5.93461 38.0441C6.13204 38.0441 6.34265 37.9924 6.51376 37.902L17.3334 32.3208L28.153 37.902C28.5742 38.1216 29.0744 38.0829 29.4824 37.7986C29.8642 37.5273 30.0616 37.0622 29.9826 36.5971L29.5746 34.2975"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M29.5746 34.3104L27.9029 24.7758L36.6429 16.417C36.9851 16.094 37.1299 15.603 36.9588 15.1509C36.814 14.7116 36.4191 14.3757 35.9584 14.3111L23.8489 12.5928L18.4522 1.83092C18.031 0.978236 16.6226 0.978236 16.2014 1.83092L10.8048 12.5928L-1.27848 14.3111C-1.76549 14.3757 -2.16037 14.7116 -2.30516 15.1509C-2.44995 15.5901 -2.31832 16.094 -1.97609 16.417L1.38036 19.621M6.75069 24.7888L4.69732 36.61C4.61835 37.0751 4.81579 37.5532 5.18434 37.8115C5.4081 37.9666 5.67135 38.0441 5.93461 38.0441C6.13204 38.0441 6.34265 37.9924 6.51376 37.902L17.3334 32.3208L28.153 37.902C28.5742 38.1216 29.0744 38.0829 29.4824 37.7986C29.8642 37.5273 30.0616 37.0622 29.9826 36.5971L29.5746 34.2975"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M29.5746 34.3104L27.9029 24.7758L36.6429 16.417C36.9851 16.094 37.1299 15.603 36.9588 15.1509C36.814 14.7116 36.4191 14.3757 35.9584 14.3111L23.8489 12.5928L18.4522 1.83092C18.031 0.978236 16.6226 0.978236 16.2014 1.83092L10.8048 12.5928L-1.27848 14.3111C-1.76549 14.3757 -2.16037 14.7116 -2.30516 15.1509C-2.44995 15.5901 -2.31832 16.094 -1.97609 16.417L1.38036 19.621M6.75069 24.7888L4.69732 36.61C4.61835 37.0751 4.81579 37.5532 5.18434 37.8115C5.4081 37.9666 5.67135 38.0441 5.93461 38.0441C6.13204 38.0441 6.34265 37.9924 6.51376 37.902L17.3334 32.3208L28.153 37.902C28.5742 38.1216 29.0744 38.0829 29.4824 37.7986C29.8642 37.5273 30.0616 37.0622 29.9826 36.5971L29.5746 34.2975"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M29.5746 34.3104L27.9029 24.7758L36.6429 16.417C36.9851 16.094 37.1299 15.603 36.9588 15.1509C36.814 14.7116 36.4191 14.3757 35.9584 14.3111L23.8489 12.5928L18.4522 1.83092C18.031 0.978236 16.6226 0.978236 16.2014 1.83092L10.8048 12.5928L-1.27848 14.3111C-1.76549 14.3757 -2.16037 14.7116 -2.30516 15.1509C-2.44995 15.5901 -2.31832 16.094 -1.97609 16.417L1.38036 19.621M6.75069 24.7888L4.69732 36.61C4.61835 37.0751 4.81579 37.5532 5.18434 37.8115C5.4081 37.9666 5.67135 38.0441 5.93461 38.0441C6.13204 38.0441 6.34265 37.9924 6.51376 37.902L17.3334 32.3208L28.153 37.902C28.5742 38.1216 29.0744 38.0829 29.4824 37.7986C29.8642 37.5273 30.0616 37.0622 29.9826 36.5971L29.5746 34.2975"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M57.516 68.6211L49.6372 78.8144"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M57.516 68.6211L49.6372 78.8144"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M57.516 68.6211L49.6372 78.8144"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M57.516 68.6211L49.6372 78.8144"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M25.2129 101.085V108.616C25.2129 110.184 24.1167 110.184 24.0311 110.184H16.7003C15.7583 110.184 15.7583 109.008 15.7583 108.336V97.5925C15.7583 97.1853 15.7583 96.0703 16.9573 96.0703H21.6674"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M25.2129 101.085V108.616C25.2129 110.184 24.1167 110.184 24.0311 110.184H16.7003C15.7583 110.184 15.7583 109.008 15.7583 108.336V97.5925C15.7583 97.1853 15.7583 96.0703 16.9573 96.0703H21.6674"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M25.2129 101.085V108.616C25.2129 110.184 24.1167 110.184 24.0311 110.184H16.7003C15.7583 110.184 15.7583 109.008 15.7583 108.336V97.5925C15.7583 97.1853 15.7583 96.0703 16.9573 96.0703H21.6674"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M25.2129 101.085V108.616C25.2129 110.184 24.1167 110.184 24.0311 110.184H16.7003C15.7583 110.184 15.7583 109.008 15.7583 108.336V97.5925C15.7583 97.1853 15.7583 96.0703 16.9573 96.0703H21.6674"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
);

export default RedeemAwardsIllustrationIcon;
